var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error"},[_vm._m(0),_c('div',{staticClass:"error__message"},[_c('p',[_vm._v(" "+_vm._s(_vm.error.message)+" ")])]),_c('div',{staticClass:"error__solution"},[_c('p',[_vm._v(" "+_vm._s(_vm.error.solution)+" ")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"error__icon"},[_c('i',{staticClass:"fas fa-exclamation-triangle"})])
}]

export { render, staticRenderFns }